import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OpenRequestsService {


  private id = 0;
  private openRequests: PendingRequest[] = [];

  constructor() { }

  generateId(): number {
    const id = this.id;
    this.id += 1;
    return id;
  }

  addRequest(id: number, url: string) {
    this.openRequests.push({id, url});
  }

  setRequestDone(id: number) {
    this.openRequests = this.openRequests.filter(it => it.id !== id);
  }

  getRequests(): PendingRequest[] {
    return this.openRequests;
  }
}

export interface PendingRequest {
  id: number;
  url: string;
}
